function c(F) {
  return (F == null ? void 0 : F.color) || "#FFFFFF";
}
export {
  c as getEnvColor
};
